export const buttons ={
    "confirm": "Confirm",
    "cancel": "Cancel",
    "approve": "Approve",
}
